if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.variantInputs = this.querySelectorAll('.js-option');
      this.hiddenVariantInput = this.querySelector('input[name="id"]');
      this.addToCartButton = this.querySelector('button[name="add"]');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
      
      this.bindVariantEvents();
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindVariantEvents() {
      this.variantInputs.forEach((input) => {
        input.addEventListener('change', this.onVariantChange.bind(this));
      });
    }

    onVariantChange(event) {
      const selectedInput = event.target;
      const variantId = selectedInput.dataset.variantId;
      const isAvailable = selectedInput.getAttribute('data-available') !== 'false';

      // Update the hidden variant input
      if (this.hiddenVariantInput && variantId) {
        this.hiddenVariantInput.value = variantId;
        this.hiddenVariantInput.disabled = false;
      }

      // Update button state
      if (this.addToCartButton) {
        this.addToCartButton.disabled = !isAvailable;
        
        if (!isAvailable) {
          this.addToCartButton.textContent = this.addToCartButton.dataset.soldOutText || 'Sold out';
        } else {
          this.addToCartButton.textContent = this.addToCartButton.dataset.addToCartText || 'Add to cart';
        }
      }

      // Update price if available
      const price = selectedInput.dataset.price;
      const compareAtPrice = selectedInput.dataset.compareAtPrice;
      this.updatePrice(price, compareAtPrice);
    }

    updatePrice(price, compareAtPrice) {
      const priceElement = this.querySelector('.price');
      if (!priceElement || !price) return;

      const formattedPrice = this.formatMoney(price);
      const priceCurrent = priceElement.querySelector('.price__current');
      const priceRegular = priceElement.querySelector('.price__regular');
      const priceSale = priceElement.querySelector('.price__sale');

      if (compareAtPrice && parseInt(compareAtPrice) > parseInt(price)) {
        // On sale - show both compare at price and sale price
        if (priceCurrent) {
          priceCurrent.innerHTML = `<span class="price__sale">${formattedPrice}</span> <span class="price__regular">${this.formatMoney(compareAtPrice)}</span>`;
        } else if (priceSale && priceRegular) {
          priceRegular.textContent = this.formatMoney(compareAtPrice);
          priceSale.textContent = formattedPrice;
        }
        priceElement.classList.add('price--on-sale');
      } else {
        // Regular price
        if (priceCurrent) {
          priceCurrent.textContent = formattedPrice;
        } else if (priceRegular) {
          priceRegular.textContent = formattedPrice;
          if (priceSale) priceSale.textContent = '';
        }
        priceElement.classList.remove('price--on-sale');
      }
    }

    formatMoney(cents) {
      // Use Shopify's money formatting if available
      if (window.theme && window.theme.moneyFormat && typeof window.formatMoney === 'function') {
        return window.formatMoney(cents, window.theme.moneyFormat);
      }
      
      // Fallback to basic formatting
      const amount = parseInt(cents) / 100;
      
      // Try to detect currency from existing price elements
      const existingPrice = document.querySelector('.price__current, .price__regular');
      let currencySymbol = '$';
      
      if (existingPrice) {
        const priceText = existingPrice.textContent || existingPrice.innerText;
        if (priceText.includes('€')) currencySymbol = '€';
        else if (priceText.includes('£')) currencySymbol = '£';
        else if (priceText.includes('¥')) currencySymbol = '¥';
      }
      
      return currencySymbol + amount.toFixed(2);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
